import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  fragment FragmentDmsFilesValueType on DmsFilesValueType {
    isFile
  }
`

export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentDmsFilesValueTypeFragment,
  ents.core.dms.data.Value.Type.Files
>({
  // NOTE: queried field is nullable; the entity discriminant is always `true`
  isFile: {
    usingFullInput: graphql.transformers.OUT.always(true),
  },
})
